import { sendMail } from '@/api/mail/index';
import { mapMailHavasToGescom } from '@/mapping/mailHavasToGescomMapper';
const TYPE_DEVIS = 'devis';
export default async function envoiMail(loadingComponent, payload) {
  if (payload.pJointes) {
    payload.mail.piecesJointes = payload.pJointes;
  }
  const mailGescom = mapMailHavasToGescom(payload.mail);
  const data = new FormData();
  data.append('mailRequest', JSON.stringify(mailGescom));
  if (payload.pJointes) {
    payload.pJointes.forEach((file) => {
      data.append(file.name, file, file.name);
    });
  }
  const params = {
    mettreEdition: payload.mettreEdition,
    societeId: payload.societeId,
    typeDonnee: TYPE_DEVIS,
    elementId: payload.elementId,
  };
  await sendMail(params, data);
  return true;
}
